@if (loaded) {
  <ion-content [fullscreen]="true">
    <ion-grid>
      <ion-row>
        <div class="ion-align-self-center main-container">
          <h1>{{ "jackpot-trigger.Confirm" | translate }}</h1>
          @if (paymentPageData) {
            <div>
              <div [innerHTML]="paymentPageData | safeHtml"></div>
            </div>
          }
          @if (isPaymenthide) {
            <div>
              <ion-button (click)="activateTriggerBtn()" class="button-1" expand="block" [disabled]="!isOnline"
                >{{ "jackpot-trigger.Activate" | translate }} £ {{ userProduct?.prize | displayCurrency }}
                {{ "jackpot-trigger.trigger" | translate }}</ion-button
                >
                <p class="no-thanks" (click)="openNoThanks()">{{ "jackpot-trigger.No" | translate }}</p>
              </div>
            }
          </div>
        </ion-row>
      </ion-grid>
      @if (!isPaymenthide) {
        <div
    style="
      padding: 0.3vh;
      border-radius: 2vh;
      min-height: 25vh;
      width: 97%;
      margin-left: 1.5%;
      margin-top: 1vh;
      height: auto;
    "
          >
          <div class="timer">
            <div class="d-flex">
              <img src="../../../assets/icon/lock key.png" alt="" class="lock" />
              <p>Secure payment</p>
            </div>
            <div>Time Left: <span #timer></span></div>
          </div>
          <div [ngClass]="isPaymentDone ? 'show' : 'hide'" style="visibility: hidden">
            <iframe
              style="border: 0; width: 100%; height: 100vh; padding: 1vh"
              #iframe
              id="myCustomIframe1"
              name="myCustomIframe1"
              (load)="load(iframe)"
              sandbox="allow-forms allow-modals allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-top-navigation"
              >
            </iframe>
          </div>
          @if (!isPaymentDone) {
            <div>
              <div style="position: absolute; width: 92%; text-align: center">
                <ion-spinner name="lines-small" diameter="40" style="color: green; margin-top: 4vh"> </ion-spinner>
              </div>
              <!--  <form action="http://localhost:8100/store/r" class="paymentWidgets" data-brands="VISA MASTER"></form> -->
              <form action="{{ origin + '/r' }}" class="paymentWidgets" data-brands="VISA MASTER"></form>
            </div>
          }
        </div>
      }
    <!-- </div> -->
  </ion-content>
}